<template>
  <div class="main-canvas">
    <b-card no-body no-header style="height:425px;">
      <div class="card-header">
        <span class="float-right">
          <b-button variant="light" class="mr-2" size="sm">
            <b-icon @click="loadData" icon="arrow-repeat" variant="dark" class="mr-1"></b-icon>
          </b-button>
        </span>
        Kostenübersicht
      </div>
      <b-table :busy="isBusy" small bordered hover :items="items" :fields="fields" table-class="table-complex">
        <template #cell(index)></template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import projectStore from '@/store/Projects';
import { getInstance } from '../auth';
const utils = require('../utils/formatting.js');

export default {
  data() {
    return {
      items: [],
      fields: [
        { key: 'Index', label: '' },
        { key: 'VeDisplayName', label: 'Vergabeeinheit' },
        { key: 'VeBudget', label: 'Budget', formatter: value => utils.numberToCurrency(value), tdClass: 'text-right' },
        {
          key: 'Beauftragt',
          label: 'Beauftragt',
          formatter: value => utils.numberToCurrency(value),
          tdClass: 'text-right'
        },
        {
          key: 'InRechnungGestellt',
          label: 'Verrechnet',
          formatter: value => utils.numberToCurrency(value),
          tdClass: 'text-right'
        }
      ],
      isBusy: false
    };
  },
  methods: {
    loadData() {
      const instance = getInstance();
      instance.getTokenSilently().then(authToken => {
        this.isBusy = true;
        this.$axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;

        this.$axios
          .get(`/api/projects/${projectStore.activeProject.DbId}/costsummary`)
          .then(response => {
            this.items = response.data;
            this.isBusy = false;
          })
          .catch(error => {
            console.log(error);
            this.isBusy = false;
          });
      });
    }
  },
  created() {
    this.loadData();
  },
  mounted() {
    var vm = this;
    this.$eventBus.$on('projectSwitched', function() {
      vm.loadData();
    });
  },
  activated() {}
};
</script>

<style>
.table-complex th,
.table-complex td:first-child {
  background-color: #efefef;
}
.table-complex td:first-child,
.table-complex th:first-child {
  border-left: 1px solid white;
}
.table-complex td:last-child,
.table-complex th:last-child {
  border-right: 1px solid white;
}
.table-complex tr:first-child th {
  border-top: 1px solid white;
}
</style>
